import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Link, useNavigate } from "react-router-dom";
import "./AllGovApprovedCouncil.css";
import { useEffect, useState } from "react";
import axios from "axios";

const AllGovApprovedCouncil = () => {
  const navigate = useNavigate();
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const [councils, setCouncils] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_BASE_URL}/councils`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((response) => {
        console.log(response);

        setCouncils(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [API_BASE_URL]);

  const handleEditCouncil = (id) => {
    navigate(`/edit-government-approved-council/${id}`);
  };

  const handleDeleteCouncil = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this council?"
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(`${API_BASE_URL}/admin/councils/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      alert("Council deleted successfully");
      // Remove the deleted council from the state
      setCouncils(councils.filter((council) => council._id !== id));
    } catch (error) {
      alert("Failed to delete council. Please try again.");
      console.error("Error deleting council:", error);
    }
  };

  return (
    <div id="all-gov-app-card-all-main">
      <div className="all-gov-app-card-heading-main">
        <h4>Gov Approved Council Table</h4>
        <div className="header-main-btns">
          <button onClick={() => navigate("/government-approved-council")}>
            Gov Approved Council
          </button>
          <button>All Gov Approved Council</button>
        </div>
      </div>
      <div className=" classes-table-container">
        <table className="classes-table">
          <thead>
            <tr>
              <th>S.No.</th>
              <th>Title</th>
              <th>Uploaded Icon</th>
              <th>Link</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {councils &&
              councils.map((item, idx) => (
                <tr key={idx}>
                  <td>{idx + 1}</td>
                  <td>{item.title}</td>
                  <td>
                    <img
                      src={`${API_BASE_URL}/uploads/${item.iconUrl}`}
                      alt=""
                      className="w-25"
                    />
                  </td>
                  <td>
                    <Link to={item.link}>{item.link}</Link>
                  </td>
                  <td>
                    <span>
                      <FaEdit onClick={() => handleEditCouncil(item._id)} />
                    </span>
                    <span>
                      <MdDelete onClick={() => handleDeleteCouncil(item._id)} />
                    </span>
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllGovApprovedCouncil;
